import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./styles.module.css";
const LoadingMessage = () => (_jsxs("span", { className: styles.loading, children: [_jsx("span", { className: styles.dot }), _jsx("span", { className: styles.dot }), _jsx("span", { className: styles.dot })] }));
export default LoadingMessage;
